import React, { Component } from "react";
import { Row, Col, Card, CardBody, FormGroup, Button,  Label, Input, Container, Spinner, Modal, ModalHeader, ModalBody,Table } from "reactstrap";
import { AvForm, AvField } from "availity-reactstrap-validation";
import { validateToken, has_Permission } from '../../helpers/jwt-token-access/accessToken'
import Dropzone from "react-dropzone";
import SweetAlert from "react-bootstrap-sweetalert";
import Select from "react-select";
import toastr from 'toastr'
import 'toastr/build/toastr.min.css'
import { Link } from "react-router-dom";
import { isEmpty } from "lodash";
//Import Breadcrumb
import Breadcrumbs from '../../components/Common/Breadcrumb';
import { BaseUrl } from "../../helpers/Baseurl"
import axios from "axios";
import ActivityLog from "./ActivityLog";


class EditLocation extends Component {
  constructor(props) {
    super(props);
    this.obj = JSON.parse(localStorage.getItem("authUser"))
    if (!this.obj){
        this.props.history.push('/logout')
    }else if (!validateToken(this.obj.access)){
        this.props.history.push('/logout')
    }
    if(!has_Permission(this.obj.user, 1, 'edit' )){
      this.props.history.push('/locations')
    }
    this.state = {
      loading: false,
      lodingstate: false,
      loadingcity:false,
      model_state:false,
      stateloading:false,
      model_city:false,
      cityloading:false,
      destinationloading:false,
      model_destination:false,
      editDestinationloading:false,
      model_editDestination:false,
      model_place:false,
      placeloading:false,

      is_place:false,
      is_destination:false,

      destination:[],
      distances:[],
      All_DestinationGroup:[], 

      all_states:[],
      Districts:[],
      Destinations:[],
      
      selected_img : null,
      state_level_location: null,
      selectedSubLocations: [], 


      selectedCountry: [], 
      selectedState: [],
      selectedCity: [],
      selectedDistrict:{ label: "", value: null },
      selectedRailway: { label: "Select Place", value: "" },
      selectedAirport: { label: "Select Place", value: "" },
      selectedBusStation: { label: "Select Place", value: "" },

      StateGroup:[],
      CountriesGroup:[],
      CityGroup:[],
      DestinationGroup:[],
      
      selectedDestination: { label: "Select Destination", value: "" }, 
      selectedDestinations: [],
      selectedEditDestination:{},
      selectedEditDistance:"",
      selectedId:"",
      default_image:null,

      selectedFiles: [],
      rejectedFiles:[],
      breadcrumbItems: [],
      PlacesGroup: [],
      count:1,
      
    };
    toastr.options = {
      positionClass: "toast-top-right",
      closeButton: "true",
      progressBar: "true",
      showEasing: "swing",
      hideEasing: "linear",
      showMethod: "fadeIn",
      hideMethod: "fadeOut",
      showDuration: 300,
      hideDuration: 1000,
      timeOut: 5000,
      extendedTimeOut: 1000
  }
    this.onInputChange = this.onInputChange.bind(this)
    this.handleImageSubmit = this.handleImageSubmit.bind(this)
    this.handleDefaultImage = this.handleDefaultImage.bind(this);   
    this.handleAddImageNameSubmit = this.handleAddImageNameSubmit.bind(this) 
    this.handleAddStateSubmit = this.handleAddStateSubmit.bind(this)
    this.handleAddCitySubmit = this.handleAddCitySubmit.bind(this)
    this.handleAddSubPlacesSubmit = this.handleAddSubPlacesSubmit.bind(this)
    this.handleDestinactionDistanceSubmit = this.handleDestinactionDistanceSubmit.bind(this)
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleSelectCountry = this.handleSelectCountry.bind(this);
    this.handleSelectState = this.handleSelectState.bind(this);
    this.handleSelectCity = this.handleSelectCity.bind(this);
    this.handleSelectedDistrict = this.handleSelectedDistrict.bind(this);
    this.handleAcceptedFiles = this.handleAcceptedFiles.bind(this);
    this.handleRejectedFiles = this.handleRejectedFiles.bind(this);
    this.handleSelectedRailway = this.handleSelectedRailway.bind(this)
    this.handleSelectedAirport = this.handleSelectedAirport.bind(this)
    this.handleSelectedBusStation = this.handleSelectedBusStation.bind(this)
    this.handleselectedEditDestination = this.handleselectedEditDestination.bind(this)
    this.handleEditDestination = this.handleEditDestination.bind(this)
    this.handleEditDestinationSubmit = this.handleEditDestinationSubmit.bind(this)
    this.handleDistanceDelete = this.handleDistanceDelete.bind(this)
    this.removeInput = this.removeInput.bind(this);
    this.addInput = this.addInput.bind(this);
    this.tog_state = this.tog_state.bind(this);
    this.tog_destination = this.tog_destination.bind(this);
    this.tog_editDestination = this.tog_editDestination.bind(this);
    this.tog_images = this.tog_images.bind(this);
    this.tog_place = this.tog_place.bind(this);
    this.tog_change_to_place = this.tog_change_to_place.bind(this)
    this.handleChangeToDestination = this.handleChangeToDestination.bind(this)
    this.handleChangeToPlace = this.handleChangeToPlace.bind(this)
    this.tog_city = this.tog_city.bind(this)
    this.tog_img_name = this.tog_img_name.bind(this)
    this.tog_state_destination = this.tog_state_destination.bind(this)
    this.handleSubLocationsSubmit = this.handleSubLocationsSubmit.bind(this)
    this.addSubLocations = this.addSubLocations.bind(this)
    this.deleteSubLocation = this.deleteSubLocation.bind(this)
  }

  tog_state() {
    this.setState(prevState => ({
      model_state: !prevState.model_state
    }));
    this.removeBodyCss();
  }
  tog_destination() {
    this.setState(prevState => ({
      model_destination: !prevState.model_destination
    }));
    this.removeBodyCss();
  }

  tog_state_destination() {
    this.setState(prevState => ({
      model_state_destination: !prevState.model_state_destination
    }));
    this.removeBodyCss();
  }
  tog_editDestination() {
    this.setState(prevState => ({
      model_editDestination: !prevState.model_editDestination
    }));
    this.removeBodyCss();
  }

  tog_city() {
    this.setState(prevState => ({
      model_city: !prevState.model_city
    }));
    this.removeBodyCss();
  }

  tog_img_name() {
    this.setState(prevState => ({
      model_img_name: !prevState.model_img_name
    }));
    this.removeBodyCss();
  }

  tog_place() {
    this.setState({selectedFiles:[], rejectedFiles:[]})
    this.setState(prevState => ({
      model_place: !prevState.model_place
    }));
    this.removeBodyCss();
  }

  tog_change_to_place() {
    this.setState(prevState => ({
      model_change_to_place: !prevState.model_change_to_place
    }));
    this.removeBodyCss();
  }

  tog_images() {
    this.setState(prevState => ({
      model_images: !prevState.model_images
    }));
    this.removeBodyCss();
  }
  removeBodyCss() {
    document.body.classList.add("no_padding");
  }


  addInput(){
    const {count} = this.state
    this.setState({count:count+1})

  }
  removeInput(){
    const {count, selectedDestinations} = this.state
    let newdata = selectedDestinations
    newdata.pop()
    this.setState({count:count-1, selectedDestinations:newdata })

  }

  componentDidCatch(error) {
    // Changing the state to true
    // if some error occurs
    console.log(error)
    toastr.error("Something Went Wrong", "")
    this.props.history.push('/locations')
  }

  async componentDidMount() { 
    this.loadData();
    this.loadCountryData();
 }
 async loadData(){
    const id =this.props.match.params.id
    const requestOptions = {
      method: 'GET',
      headers: { 'Content-Type': 'application/json' },
    };
    fetch(`${BaseUrl}/api/locations/location/locations/${id}/`,requestOptions)
        .then(res => {
            if (res.status <400){
                res.json()
                .then(
                    async (data) => {  
                      document.title = "Edit "+data.location.name+" | Planmans";      
                      let breadcrumbItems= [
                        { title: "Locations", link: `/locations` },
                        { title: `${data.location.name} detail`, link: `/location/${data.location.id}` },
                        { title: `Edit ${data.location.name} detail`, link: "#" },
                      ]

                      let selectedDestination =  { label: "Select Destination", value: "" } 
                      let selectedCountry = { label: data.location.country.name, value: data.location.country.id }
                      let selectedState = { label: data.location.state.name, value: data.location.state.id }
                      let selectedCity = { label: data.location.city.name, value: data.location.city.id }
                      let selectedRailway= { label: "Select Place", value: "" }
                      let selectedAirport= { label: "Select Place", value: "" }
                      let selectedBusStation= { label: "Select Place", value: "" }
                      let selectedDistrict={ label: "", value: null }
                      let elevation = data.location.elevation
                      let area = data.location.area
                      let weather = data.location.weather
                      let climate = data.location.climate
                      let bus_station_distance = data.location.bus_station_distance
                      let railway_distance = data.location.railway_distance
                      let airport_distance = data.location.airport_distance
                      if(data.location.nearest_railway_station){
                        selectedRailway = { label: data.location.nearest_railway_station.name, value: data.location.nearest_railway_station.id }
                      }
                      if(data.location.nearest_airport){
                        selectedAirport = { label: data.location.nearest_airport.name, value: data.location.nearest_airport.id }
                      }
                      if(data.location.nearest_bus_station){
                        selectedBusStation = { label: data.location.nearest_bus_station.name, value: data.location.nearest_bus_station.id }
                      }
                      if(data.location.district){
                        selectedDistrict={ label: data.location.district.name, value: data.location.district.id }
                      }
                      let default_image = null
                      for(let i=0; i< data.location.image.length; i++){
                        if (data.location.image[i].is_default){
                          default_image = data.location.image[i]
                        }
                      }
                      if(data.location.state_level){
                        this.loadStateLevelLocations(data.location.id)
                      }
                      let is_place = false
                      let is_destination = false
                      if (data.location.parent){
                        is_place = true
                        selectedDestination = { label: data.location.parent.name, value: data.location.parent.id }
                      }else{
                        is_destination = true
                        this.loadAllDestinations('?parent=null',data.location, data.distance)
                      }
                      let options=[]
                      for (let j in data.location.state.district){
                        options.push({ label:data.location.state.district[j].name, value: data.location.state.district[j].id })
                      }  
                      let Districts = [
                        { 
                            label: "District",
                            options: options
                        }]
                        await this.loadStateLocations(`${BaseUrl}/api/locations/location/locations/?state__id=${data.location.state.id}`)
                        this.loadDestinations(data.location.state.id)
                        await this.loadStateData(selectedCountry.value)
                        await this.loadCityData(selectedState.value)
                        this.setState({ destination:data.location,
                                        breadcrumbItems:breadcrumbItems,
                                        distances:data.distance,
                                        selectedCountry:selectedCountry,
                                        selectedState:selectedState,
                                        selectedCity: selectedCity,
                                        selectedRailway: selectedRailway,
                                        selectedAirport: selectedAirport,
                                        selectedBusStation: selectedBusStation,
                                        selectedDestination:selectedDestination,
                                        default_image:default_image,
                                        bus_station_distance:bus_station_distance,
                                        railway_distance:railway_distance,
                                        airport_distance:airport_distance,
                                        selectedDistrict,
                                        destinationloading:false,
                                        preloader : false,
                                        model_change_to_place:false,
                                        model_destination:false,
                                        model_editDestination:false,
                                        editDestinationloading:false,
                                        model_img_name:false,
                                        imagenameloading:false,
                                        selectedDestinations:[],
                                        selectedEditDestination:[],  
                                        selectedEditDistance:"",
                                        selectedId:"",
                                        gallery_loading:false,
                                        is_destination:is_destination,
                                        is_place:is_place,
                                        elevation:elevation,
                                        area:area,
                                        weather:weather,
                                        climate:climate,
                                        Districts:Districts,
                                                                          
                                  })   
                                  
                    },
                    (error) => {
                        console.log(error, 'error--------------') 
                    }
                )
            }else{
                this.props.history.push('/locations')
            }
        })
          
 }

 async loadStateLevelLocations(id){
  const requestOptions = {
    method: 'GET',
    headers: { 'Content-Type': 'application/json' },
  };
  fetch(`${BaseUrl}/api/locations/location/state-level-locations/?destination=${id}`,requestOptions)
      .then(res => {
          if (res.status <400){
              res.json()
              .then(
                  (data) => {  
                    console.log(data, "--------------statelevel")
                  this.setState({state_level_location: data[0]})
                  },
                  (error) => {
                      console.log(error, 'error--------------') 
                  }
              )
          }else{
              this.props.history.push('/locations')
          }
      })
        
 }


 async loadStateLocations(url){
  const requestOptions = {
    method: 'GET',
    headers: { 'Content-Type': 'application/json' },
  };
  fetch(url,requestOptions)
      .then(res => {
          if (res.status <400){
              res.json()
              .then(
                  async (data) => {  
                  console.log(data)
                  },
                  (error) => {
                      console.log(error, 'error--------------') 
                  }
              )
          }else{
              this.props.history.push('/locations')
          }
      })
        
 }

 async loadCountryData(){

  const requestOptions = {
    method: 'GET',
    headers: { 'Content-Type': 'application/json' },
  };
  await fetch(`${BaseUrl}/api/locations/location/countries/`,requestOptions)
      .then(res => res.json())
      .then(
          (data) => {
              let options = []
              data.map(country => {
                  options.push({ label: country.name, value: country.id })
                })
             
                let CountriesGroup = [
                  { 
                      label: "Country",
                      options: options
                  }
              ];
              this.setState({ CountriesGroup:CountriesGroup  }) 
                  
             
          },
          (error) => {
              console.log(error, 'error--------------') 
          }
      )  
 }

 async loadStateData(country){
   this.setState({lodingstate:true})

  const requestOptions = {
    method: 'GET',
    headers: { 'Content-Type': 'application/json' },
  };
  await fetch(`${BaseUrl}/api/locations/states/${country}/`,requestOptions)
      .then(res => res.json())
      .then(
          (data) => {
              let options = []
              data.map(state => {
                  options.push({ label: state.name, value: state.id })
                })
             
                let StateGroup = [
                  { 
                      label: "State",
                      options: options
                  }
              ];
              this.setState({ StateGroup:StateGroup, lodingstate:false , all_states:data })
                     
             
          },
          (error) => {
              console.log(error, 'error--------------') 
          }
      )  
 }

 async loadCityData(state){
  this.setState({loadingcity:true})
  const requestOptions = {
    method: 'GET',
    headers: { 'Content-Type': 'application/json' },
  };
  await fetch(`${BaseUrl}/api/locations/cities/${state}/`,requestOptions)
      .then(res => res.json())
      .then(
          (data) => {
              let options = []
              data.map(city => {
                  options.push({ label: city.name, value: city.id })
                })
             
                let CityGroup = [
                  { 
                      label: "City",
                      options: options
                  }
              ];
              this.setState({ CityGroup:CityGroup, loadingcity:false  })      
             
          },
          (error) => {
              console.log(error, 'error--------------') 
          }
      )  
 }

 async loadDestinations(state){

    const requestOptions = {
      method: 'GET',
      headers: { 'Content-Type': 'application/json' },
    };
    await fetch(`${BaseUrl}/api/locations/destinations/${state}/`,requestOptions)
        .then(res => res.json())
        .then(
            (data) => {
                let options = []
                data.map(destination => {
                    options.push({ label: destination.name, value: destination.id })
                  })
              
                  let DestinationGroup = [
                    { 
                        label: "Destination",
                        options: options
                    }
                ];
                this.setState({ DestinationGroup:DestinationGroup  })      
              
            },
            (error) => {
                console.log(error, 'error--------------') 
            }
        )  
  }

 async loadStateLocationsData(filter_data){
    const requestOptions = {
      method: 'GET',
      headers: { 'Content-Type': 'application/json' },
    };
    await fetch(`${BaseUrl}/api/locations/location/locations/?size=50&${filter_data}`,requestOptions)
        .then(res => res.json())
        .then(
            (data) => {
                let options = []
                data.results.map(place => {
                    options.push({ label: place.name, value: place.id })
                    })
                
                    let PlacesGroup = [
                    { 
                        label: "Location",
                        options: options
                    }
              ];
                
                this.setState({ PlacesGroup:PlacesGroup, placeloading: false, model_place:false ,lodingNearestPlace:false })      
                
            },
            (error) => {
                console.log(error, 'error--------------') 
            }
        )  
    }

 async loadAllDestinations(filer_queryset,destination, distances){

    const requestOptions = {
      method: 'GET',
      headers: { 'Content-Type': 'application/json' },
    };
    await fetch(`${BaseUrl}/api/locations/location/locations/${filer_queryset}`,requestOptions)
        .then(res => res.json())
        .then(
            (data) => {
                let options = []
                let selectedDestinations = []
                for(let i=0; i<distances.length; i++){
                    selectedDestinations.push(distances[i].destination.id)
                }
                data.results.map(destini => {
                    if(destination.id !== destini.id && !selectedDestinations.includes(destini.id)){
                        options.push({ label: destini.name, value: destini.id })
                    }
                        
                  })
              
                  let All_DestinationGroup = [
                    { 
                        label: "Destination",
                        options: options
                    }
                ];
                this.setState({ All_DestinationGroup:All_DestinationGroup  })      
              
            },
            (error) => {
                console.log(error, 'error--------------') 
            }
        )  
  }

  async loadDestinationData(destination){

  const requestOptions = {
      method: 'GET',
      headers: { 'Content-Type': 'application/json' },
  };
  await fetch(`${BaseUrl}/api/locations/location/locations/${destination}/`,requestOptions)
      .then(res => res.json())
      .then(
          (data) => {
              let elevation = data.elevation
              let area = data.area
              let weather = data.weather
              let climate = data.climate
              let selectedRailway= { label: "Select Place", value: "" }
              let selectedAirport= { label: "Select Place", value: "" }
              let selectedBusStation= { label: "Select Place", value: "" }
              let bus_station_distance = data.bus_station_distance
              let railway_distance = data.railway_distance
              let airport_distance = data.airport_distance
              if(data.nearest_railway_station){
                  selectedRailway = { label: data.nearest_railway_station.name, value: data.nearest_railway_station.id }
                }
                if(data.nearest_airport){
                  selectedAirport = { label: data.nearest_airport.name, value: data.nearest_airport.id }
                }
                if(data.nearest_bus_station){
                  selectedBusStation = { label: data.nearest_bus_station.name, value: data.nearest_bus_station.id }
                }

              
              this.setState({ 
                  elevation:elevation,
                  area:area,
                  weather:weather,
                  climate:climate,
                  selectedRailway:selectedRailway,
                  selectedAirport:selectedAirport,
                  selectedBusStation:selectedBusStation,
                  bus_station_distance: bus_station_distance,
                  railway_distance:railway_distance,
                  airport_distance:airport_distance

                })      
              
          },
          (error) => {
              console.log(error, 'error--------------') 
          }
      )  
  }

  handleLoadNearestPlaces(filter_data){
    this.setState({lodingNearestPlace:true})
    this.loadStateLocationsData(filter_data)
  }

 handleSelectCountry = selectedCountry => {
    this.loadStateData(selectedCountry.value)
    this.setState({ selectedCountry  })
  };

  handleSelectState = selectedState => {
    const {all_states } = this.state
    let options= []
    for (let i in all_states){
      if(all_states[i].id === selectedState.value){
        let district = all_states[i].district
        for (let j in district){
          options.push({ label: district[j].name, value: district[j].id })
        }
      }
    }
    let Districts = [
      { 
          label: "District",
          options: options
      }
    ];

    this.loadCityData(selectedState.value)
    this.loadDestinations(selectedState.value)
    this.setState({ selectedState, Districts })
 };

 handleSelectedDistrict = selectedDistrict => {
  this.setState({ selectedDistrict })
 }
 handleSelectCity = selectedCity => {
    this.setState({ selectedCity });
  };
  handleSelectedRailway = selectedRailway => {
    this.setState({ selectedRailway  })
  }

  handleSelectedAirport = selectedAirport => {
    this.setState({ selectedAirport  })
  }
  handleSelectedBusStation = selectedBusStation => {
    this.setState({ selectedBusStation  })
  }
  handleselectedEditDestination = selectedEditDestination => {
    this.setState({ selectedEditDestination  })
  }

  handleselectedNearestDestination = selectedDestination =>{
    this.loadDestinationData(selectedDestination.value)
    this.setState({ selectedDestination  })
  }

  handleselectedParentDestination = selectedDestination =>{

    this.setState({ selectedDestination  })
  }

  onInputChange(e){
    const {destination,distances} = this.state
    this.loadAllDestinations(`?parent=null&search=${e}`, destination, distances)
  }

  SetValueInInputEvent( obj, event ) {
    var events = new Event( event, {target: obj, bubbles: true} );
    return obj ? obj.dispatchEvent(events) : false;
}

  handleSelectedDestinations = (selectedStation, index) => {
    
    const {selectedDestinations, destination} = this.state
    if(selectedDestinations.includes(selectedStation.value)){
      toastr.error(`${selectedStation.label} already selected`,"")
    }
    else{
      let newdata = selectedDestinations
      let value = selectedStation.value
      if ((newdata.length)-1 < index){
        newdata.push(value)
      }else{
          newdata[index] = value
      }
      const requestOptions = {
        method: 'GET',
        headers: { 'Content-Type': 'application/json' },
    };
    fetch(`${BaseUrl}/api/locations/location/destination_distance/?from_destination__id=${selectedStation.value}&destination__id=${destination.id}`,requestOptions)
        .then(res => res.json())
        .then(
            (data) => {
              if (data.length > 0){
                var el = document.getElementById(index+"");
                el.value = data[0].distance;
                this.SetValueInInputEvent( el, 'input' );  
              }           
                
              this.setState({ selectedDestinations:newdata })
                
            },
            (error) => {
                console.log(error, 'error--------------') 
            }

        )

      
    }

  } 

  handleAcceptedFiles = files => {
    files.map(file =>
      Object.assign(file, {
        preview: URL.createObjectURL(file),
        formattedSize: this.formatBytes(file.size)
      })
    );
    this.setState({ selectedFiles: files });
  };

  handleRejectedFiles = files => {
    files.map(file =>
      Object.assign(file, {
        preview: URL.createObjectURL(file),
        formattedSize: this.formatBytes(file.size)
      })
    );
    this.setState({ rejectedFiles : files });
  } 

  formatBytes = (bytes, decimals = 2) => {
    if (bytes === 0) return "0 Bytes";
    const k = 1024;
    const dm = decimals < 0 ? 0 : decimals;
    const sizes = ["Bytes", "KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"];

    const i = Math.floor(Math.log(bytes) / Math.log(k));
    return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + " " + sizes[i];
  };

  handleAddState(){
    if (this.state.selectedCountry.value === null){
      toastr.error(`Please Select Country First`,"")
    }else{
      this.tog_state()
    }
  }

  handleAddCity(){
    if (this.state.selectedState.value === null){
      toastr.error(`Please Select State First`,"")
    }else{
      this.tog_city()
    }
  }

  handleAddStateSubmit(e, value){
    this.setState({ stateloading: true})
    let new_data = {}
          new_data["name"] = value.name
          new_data["country"] = this.state.selectedCountry.value
          axios.post(
            `${BaseUrl}/api/locations/states/`,
            new_data,
            {
                headers: {
                    "Content-type": "application/json",
                },                    
            }
          ).then(res => {
            let selectedState = { label: res.data.name, value: res.data.id }
            this.loadStateData(this.state.selectedCountry.value)
            this.setState({model_state:false, stateloading:false, selectedState:selectedState })

          }).catch(err => {
            console.log(err, "----------------------error");
            })
  }

  handleAddCitySubmit(e, value){
    this.setState({ cityloading: true})
    let new_data = {}
          new_data["name"] = value.name
          new_data["state"] = this.state.selectedState.value
          axios.post(
            `${BaseUrl}/api/locations/cities/`,
            new_data,
            {
                headers: {
                    "Content-type": "application/json",
                },                    
            }
          ).then(res => {
            toastr.success(`City ${res.data.name} Added`,"") 
            let selectedCity = { label: res.data.name, value: res.data.id }
            this.loadCityData(this.state.selectedState.value)
            this.setState({model_city:false, cityloading:false, selectedCity:selectedCity })

          }).catch(err => {
            console.log(err, "----------------------error");
            })
  
  }
  
  handleAddImageNameSubmit(e, values){
    const { selected_img } = this.state
    if (selected_img){
      this.setState({imagenameloading:true})
    let data = {"name": values.name}
    const requestOptions = {
      method: 'PUT',
      headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${this.obj.access}` },
      body: JSON.stringify(data)
      };
      fetch(`${BaseUrl}/api/locations/location/images/${selected_img.id}/`,requestOptions)
      .then(res => 
          {if(res.status >= 400){
              res.json()
              .then(
                  (data) =>{  
                    console.log(data, "error data") 
                    this.setState({ model_img_name:false, imagenameloading:false })
                  }     
              )
          }
          else{
            this.loadData()
          }    
      }
    )

    }else{
      toastr.error("Somthing went wrong", "Please Try Again")
      this.setState({ model_img_name:false, imagenameloading:false })
    }
    

  }

  handleDefaultImage = item =>{
    this.setState({ gallery_loading:true })
    let data ={}
    data['name'] = item.name
    data['is_default'] = true
    const requestOptions = {
      method: 'PUT',
      headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${this.obj.access}` },
      body: JSON.stringify(data)
      };
      fetch(`${BaseUrl}/api/locations/location/images/${item.id}/`,requestOptions)
      .then(res => 
          {if(res.status >= 400){
              res.json()
              .then(
                  (data) =>{  
                    console.log(data, "error data")
                    toastr.error("Something Went Wrong", "") 
                    this.setState({ gallery_loading:false})
                  }     
              )
          }
          else{
              const {default_image} = this.state
                    if (default_image){
                      let newdata ={}
                      newdata['name'] = default_image.name
                      newdata['is_default'] = false
                      const requestOptions = {
                        method: 'PUT',
                        headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${this.obj.access}` },
                        body: JSON.stringify(newdata)
                        };
                        fetch(`${BaseUrl}/api/locations/location/images/${default_image.id}/`,requestOptions)
                        .then(res => 
                            {if(res.status >= 400){
                                res.json()
                                .then(
                                    (data) =>{  
                                      console.log(data, "error data") 
                                      this.setState({ gallery_loading:false})
                                    }     
                                )
                            }
                            else{
                              this.loadData()
                            }    
                        }
                      ) 

                    }else{
                      this.loadData()
                    }

                  }    
      }
    )
  } 

  handleImageSubmit(e, values){
    if(this.state.selectedFiles.length === 0){

      toastr.error(`Select Images`,"") 
    }
    else{
        const { destination } = this.state
        this.setState({imagesloading:true})
        const formData = new FormData();
        const img = this.state.selectedFiles
        for(let i=0 ; i<img.length; i++){
          formData.append(
            "image",
            this.state.selectedFiles[i]
        );
        formData.append("name",values.image_name)
        axios.post(
          `${BaseUrl}/api/locations/images/`,
          formData,
          {
              headers: {
                  "Content-type": "multipart/form-data",
              },                    
          }
        )
        .then(res => {         
          let images = []
          for(let i=0 ; i<destination.image.length; i++){
              images.push(destination.image[i].id)
            
          }
          for(let i=0 ; i<res.data.length; i++){
            images.push(res.data[i].id)
          
          }          
          let data = {}
          data['image'] = images
          const requestOptions = {
              method: 'PUT',
              headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${this.obj.access}` },
              body: JSON.stringify(data)
              };
              fetch(`${BaseUrl}/api/locations/location/locations/${destination.id}/`,requestOptions)
              .then(res => 
                  {if(res.status >= 400){
                      res.json()
                      .then(
                          (data) =>{  
                            console.log(data, "error data")
                            toastr.error("Something Went Wrong", "") 
                            this.setState({ imagesloading: false, model_images:false,selectedFiles:[]})
                          }     
                      )
                  }
                  else{
                      res.json()
                      .then(
                          (data) =>{
                            this.loadData()
                            toastr.success("Images Added", "") 
                            this.setState({ imagesloading: false, model_images:false, gallery_loading: true, selectedFiles:[]})
                          
                          }
                      )
                  }    
              }
            )
        })
        .catch(err => {
          toastr.error(`Somthing Went Wrong`,"") 
          this.setState({ imagesloading: false , model_images:false})
            console.log(err, "----------------------error");
          })

        }
    }
  }

  handleImageDelete = id => {    
    const requestOptions = {
        method: 'DELETE',
        headers: { 'Authorization': `Bearer ${this.obj.access}` },
    
        };
          fetch(`${BaseUrl}/api/locations/location/images/${id}/`,requestOptions)
                .then(res => 
                    {if(res.status >= 400){
                      console.log("error")
                    }
                    else{
                      this.setState({
                        selectedId:"",
                        image_success_confirm: true,
                        image_alert_confirm : false,
                        dynamic_title: "Deleted!",
                        gallery_loading: true,
                        dynamic_description: "Image has been deleted."
                        })
                        this.loadData()
                    }
                }
            )
  }


  handleEditDestination(item){
    this.setState({
      selectedEditDestination: { label: item.destination.name, value: item.destination.id },
      selectedEditDistance:item.distance,
      selectedId:item.id
  })
  this.tog_editDestination()
  }

  handleEditDestinationSubmit(e, values){
    this.setState({editDestinationloading:true})
    const {selectedId, selectedEditDestination, destination} = this.state
    let data = {}
    data['destination'] = selectedEditDestination.value
    data['from_destination'] = destination.id
    data['distance'] = values.destinationDistance
    const requestOptions = {
      method: 'PUT',
      headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${this.obj.access}` },
      body: JSON.stringify(data)
      };
      fetch(`${BaseUrl}/api/locations/location/destination_distance/${selectedId}/`,requestOptions)
            .then(res => 
                {if(res.status >= 400){
                    res.json()
                    .then(
                        (data) =>{  
                            console.log(data, "error data")
                          toastr.error("Something Went Wrong", "") 
                          this.setState({ loading: false })
                        }     
                    )
                }
                else{
                  this.loadData()
                }    
            }
        )  
  }

  handleDestinactionDistanceSubmit(){
    const { destination } = this.state
    this.setState({ destinationloading:true })
    let distance = []
    let destinations = this.state.selectedDestinations
    if (destinations.length === 0){
      toastr.error(`Please Select Destination and Distance`,"")
      this.setState({ destinationloading:false })
    }
    else{
      for (let i=0; i<this.state.selectedDestinations.length; i++){
        distance.push(document.getElementById(`${i}`).value)
      }
      let new_data = {}
          new_data["from_destination"] = destination.id
          new_data["destination"] = destinations
          new_data["distance"] = distance
          axios.post(
            `${BaseUrl}/api/locations/location/destination_distance/`,
            new_data,
            {
                headers: {
                    "Content-type": "application/json",
                },                    
            }
          ).then(res => {
            this.loadData()
    
          }).catch(err => {
            console.log(err, "----------------------error");
            })
    }
  }

  handleDistanceDelete(id){
    const requestOptions = {
      method: 'DELETE',
      headers: { 'Authorization': `Bearer ${this.obj.access}` },
  
      };
        fetch(`${BaseUrl}/api/locations/location/destination_distance/${id}/`,requestOptions)
              .then(res => 
                  {if(res.status >= 400){
                    console.log("error")
                  }
                  else{
                    this.loadData();
                    this.setState({
                      selectedId:"",
                      success_confirm: true,
                      alert_confirm : false,
                      dynamic_title: "Deleted!",
                      dynamic_description: "Distance has been deleted."
                      })
                      this.loadData()
                  }
              }
          )
  }

  handleAddSubPlacesSubmit(e, values){
    const { destination, selectedState, selectedCity,selectedCountry , is_place,selectedFiles, selectedDistrict} = this.state

    if(selectedFiles.length === 0){
    
      toastr.error(`Select Images`,"") 
    }else{
      this.setState({ placeloading: true })
      const formData = new FormData();
        const img = selectedFiles
        for(let i=0 ; i<img.length; i++){
          formData.append(
            "image",
            selectedFiles[i]
        );
      }
      formData.append("name",values.place_name)
      formData.append("country",selectedCountry.value)
      formData.append("state",selectedState.value)
      formData.append("city",selectedCity.value)
      formData.append("district", selectedDistrict.value)
      formData.append("zip_code",document.getElementById("zip_code").value)
      formData.append("description",document.getElementById("textarea").value)
      formData.append("elevation",document.getElementById("elevation").value)
      formData.append("area",document.getElementById("area").value)
      formData.append("weather",document.getElementById("weather").value)
      formData.append("climate",document.getElementById("climate").value)
      formData.append("parent",is_place? destination.parent.id: destination.id)

      axios.post(
        `${BaseUrl}/api/locations/add_location/`,
        formData,
        {
            headers: {
                "Content-type": "multipart/form-data",
            },                    
        }
        )
        .then(res => {if(res.status >= 400){
                console.log(res.data, "-error")
                toastr.error("Something Went Wrong", "") 
                this.setState({ placeloading: false, model_place:false })
            }
            else{
                toastr.success(`${res.data.name} Added Successully`, "")   
            }    
        }
        )
        .catch(err => {
          toastr.error("Something Went Wrong", "") 
          this.setState({ placeloading: false, model_place:false })
            console.log(err, "----------------------error");
        })

    }
   
  }

  handleSubmit(e, values) {
    const { destination, is_place,selectedDistrict } = this.state
    let description = document.getElementById("textarea").value 
    this.setState({ loading: true })
    let images = []
    for(let i=0 ; i<destination.image.length; i++){
        images.push(destination.image[i].id) 
    }
    let data = {}
    if( is_place){
        data['destination_distance'] = values.destination_distance
        data["parent"] = this.state.selectedDestination.value
    }
    data["name"] = values.name
    data["country"] = this.state.selectedCountry.value
    data["state"] = this.state.selectedState.value
    data["city"] = this.state.selectedCity.value
    data["district"] = selectedDistrict.value
    data["zip_code"] = values.zip_code
    data["description"] = description
    data["nearest_bus_station"] = this.state.selectedBusStation.value
    data["bus_station_distance"] = values.bus_station_distance
    data["nearest_railway_station"] = this.state.selectedRailway.value
    data["railway_distance"] = values.railway_distance
    data["nearest_airport"] = this.state.selectedAirport.value
    data["airport_distance"] = values.airport_distance
    data["elevation"] = values.elevation
    data["area"] = values.area
    data["weather"] = values.weather
    data["climate"] = values.climate
    data["coordinates"] = values.coordinates
    data["image"] = images
    const requestOptions = {
      method: 'PUT',
      headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${this.obj.access}` },
      body: JSON.stringify(data)
      };
      fetch(`${BaseUrl}/api/locations/location/locations/${destination.id}/`,requestOptions)
            .then(res => 
                {if(res.status >= 400){
                    res.json()
                    .then(
                        (data) =>{
                            for(let i in data){
                              toastr.error(data[i][0], i)
                            }
                            console.log(data, "------error data")
                          this.setState({ loading: false })
                        }     
                    )
                }
                else{
                    res.json()
                    .then(
                        (data) =>{
                            this.props.history.push(`/location/${data.id}`)
                        
                        }
                    )
                }    
            }
        )  
    }

  handleChangeToDestination(){
    const { destination } = this.state
    this.setState({ preloader: true })
    let data = {"destination_distance":"", "parent":""}
    const requestOptions = {
      method: 'PUT',
      headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${this.obj.access}` },
      body: JSON.stringify(data)
      };
      fetch(`${BaseUrl}/api/locations/location/locations/${destination.id}/`,requestOptions)
            .then(res => 
                {if(res.status >= 400){
                    res.json()
                    .then(
                        (data) =>{  
                            console.log(data, "error data")
                          toastr.error("Something Went Wrong", "") 
                          this.setState({ loading: false, preloader : false, })
                        }     
                    )
                }
                else{
                  this.loadData()
                  this.setState({
                    preloader : false,
                    destination_success_confirm: true,
                    destination_alert_confirm : false,
                    dynamic_title: "Changed!",
                    gallery_loading: true,
                    dynamic_description: `${destination.name} Successfully Change to as Destination`
                    })
                 
                }    
            }
        )  
  }

  handleChangeToPlace(){
    const { destination, selectedDestination } = this.state
    this.setState({ preloader: true })
    let data = {"location":destination.id, "parent":selectedDestination.value}
    const requestOptions = {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${this.obj.access}` },
      body: JSON.stringify(data)
      };
      fetch(`${BaseUrl}/api/locations/change-destination-to-place/`,requestOptions)
            .then(res => 
                {if(res.status >= 400){
                    res.json()
                    .then(
                        (data) =>{  
                            console.log(data, "error data")
                          toastr.error("Something Went Wrong", "") 
                          this.setState({ preloader : false, })
                        }     
                    )
                }
                else{
                  this.loadData()
                 
                 
                }    
            }
        )  
  }

  handleSubLocationsSubmit(data, id, del=""){
    const {destination} = this.state
          
          axios.put(
            `${BaseUrl}/api/locations/location/state-level-locations/${id}/`,
            data,
            {
                headers: {
                    "Content-type": "application/json",
                },                    
            }
          ).then(res => {
            this.loadStateLevelLocations(destination.id)
            if (del === "delete"){
              this.setState({

                selectedId:"",
                sub_location_success_confirm: true,
                alert_sub_location_confirm : false,
                dynamic_title: "Deleted!",
                dynamic_description: "Location has been deleted." })
              
            }else{
              this.tog_state_destination()
            }


          }).catch(err => {
            console.log(err, "----------------------error");
            })
  }

  addSubLocations(){
      const {state_level_location,selectedSubLocations} = this.state
      this.setState({ stateloading: true})
      let sub_locations = []
      if(state_level_location){
        for(let i=0 ; i< state_level_location.sub_locations.length; i++){
          sub_locations.push(state_level_location.sub_locations[i].id)
        }
      }
      for(let i=0 ; i< selectedSubLocations.length; i++){
        if(!sub_locations.includes(selectedSubLocations[i].value))
        sub_locations.push(selectedSubLocations[i].value)
      }
      let new_data = {"sub_locations":sub_locations, "location": state_level_location.location}
      this.handleSubLocationsSubmit(new_data, state_level_location.id)

  }

  deleteSubLocation(id){
    const {state_level_location} = this.state
      let sub_locations = []
      for(let i=0 ; i< state_level_location.sub_locations.length; i++){
        if(state_level_location.sub_locations[i].id !== id){
          sub_locations.push(state_level_location.sub_locations[i].id)
        }  
      }
      let new_data = {"sub_locations":sub_locations, "location": state_level_location.location}
      this.handleSubLocationsSubmit(new_data, state_level_location.id, 'delete')

  }

  render() {
    const { CountriesGroup, selectedCountry, selectedState, StateGroup, selectedCity,
            CityGroup,lodingstate, loadingcity, selectedRailway, selectedAirport,
            DestinationGroup,selectedBusStation , destination, distances, All_DestinationGroup, PlacesGroup,
            selectedDestination, lodingNearestPlace, Destinations, state_level_location } = this.state;
    const CustomMenu = ({ innerRef, innerProps, isDisabled, children }) =>
    lodingstate? (
      <Spinner className="me-2 mt-2" color="primary" />
    ):(
        !isDisabled ? (
            <div id="add_state" ref={innerRef} {...innerProps} className="customReactSelectMenu">
                {children}
                {has_Permission(this.obj.user, 9, 'create' )?
                <Link to="#" onClick={() => this.handleAddState()}  className="text-warning"><i className="mdi mdi-plus font-size-18"></i></Link>
                :null}
                </div>
        ) : null
    )

        const CustomCity = ({ innerRef, innerProps, isDisabled, children }) =>
        loadingcity?
        ( <Spinner className="me-2 mt-2" color="primary" />):(
        !isDisabled ? (
            <div ref={innerRef} {...innerProps} className="customReactSelectMenu">
                {children}
                {has_Permission(this.obj.user, 9, 'create' )?
                <Link to="#" onClick={() => this.handleAddCity()}  className="text-warning"><i className="mdi mdi-plus font-size-18"></i></Link>
                :null}
            </div>
        ) : null
        )

        const AddPlaces = ({ innerRef, innerProps, isDisabled, children }) =>
        lodingNearestPlace? (
          <Spinner className="me-2 mt-2" color="primary" />
        ):(
        !isDisabled ? (
          <div id="add_state" ref={innerRef} {...innerProps} className="customReactSelectMenu">
              {children}
              {has_Permission(this.obj.user, 1, 'create' )?
              <Link to="#" onClick={() => this.tog_place()}  className="text-warning"><i className="mdi mdi-plus font-size-18"></i></Link>
              :null}
          </div>
      ) : null)
   
    return (
      <React.Fragment>
        {this.state.preloader?
        <div id="preloader">
            <div id="status">
                <div className="spinner">
                    <i className="ri-loader-line spin-icon"></i>
                </div>
            </div>
        </div>
        :
        <div className="page-content">
          <Container fluid={true}>
            <Breadcrumbs title={"Edit "+(destination.name? destination.name: "Location")} breadcrumbItems={this.state.breadcrumbItems} />
            {!isEmpty(destination)?
              <>
              <Row>
                    <Col xl="6">
                    <Card>
                        <CardBody> 
                      
                            <Row>
                              {this.state.is_destination?
                                <Col md="6">
                                <Button color="dark" outline className="waves-effect me-1 mb-3 "  onClick={this.tog_change_to_place}>
                                    Change to Place
                                </Button>
                                </Col>:null
                              }
                              {this.state.is_place?
                                <Col md="6">
                                <Button color="dark" outline className="waves-effect me-1 mb-3 "  onClick={() =>this.setState({ destination_alert_confirm: true })}>
                                    Change to Destination
                                </Button>
                                </Col>:null
                              }
                             
                            </Row> 
               

                                                      
                        </CardBody>
                    </Card>
                    </Col>
                </Row>
                <AvForm className="needs-validation" onValidSubmit={this.handleSubmit} >
                <Row>
                    <Col xl="6">
                    <Card>
                        <CardBody> 
                        <h4 className="card-title">Location Detail</h4>
                            <Row>
                            <Col md="12">
                                <div className="mb-3">
                                <Label className="form-label " htmlFor="name">Name</Label>
                                <AvField
                                    name="name"
                                    placeholder="Name"
                                    type="text"
                                    value={destination.name}
                                    errorMessage="Enter Place Name"
                                    className="form-control"
                                    validate={{ required: { value: true } }}
                                    id="name"
                                    
                                />
                                </div>
                            </Col> 
                            
                            
                        
                            </Row> 
                            <Row>
                            <Col md="6">
                                <div className="mb-3">
                                    <Label className="form-label">Country</Label>
                                    <Select 
                                    value={selectedCountry}
                                    onChange={this.handleSelectCountry}
                                    options={CountriesGroup}
                                    classNamePrefix="select2-selection"
                                    />

                                </div>
                            </Col>
                        
                            <Col md="6">
                                <div className="mb-3">
                                    <Label className="form-label">State</Label>
                                    <Select 
                                    value={selectedState}
                                    onChange={this.handleSelectState}
                                    options={StateGroup}
                                    components={{ Menu: CustomMenu }}
                                    classNamePrefix="select2-selection"
                                    />

                                </div>
                            </Col>

                            </Row> 
                            <Row>
                            <Col md="6">
                                <div className="mb-3">
                                    <Label className="form-label">District</Label>
                                    <Select 
                                    value={this.state.selectedDistrict}
                                    onChange={this.handleSelectedDistrict}
                                    options={this.state.Districts}
                                    // components={{ Menu: CustomMenu }}
                                    classNamePrefix="select2-selection"
                                    />

                                </div>
                            </Col>
                            <Col md="6">
                                <div className="mb-3">
                                    <Label className="form-label">City</Label>
                                    <Select 
                                    value={selectedCity}
                                    onChange={this.handleSelectCity}
                                    options={CityGroup}
                                    components={{ Menu: CustomCity }}
                                    classNamePrefix="select2-selection"
                                    />

                                </div>
                            </Col>
                            </Row> 
                            <Row>
                            <Col md="6">
                                <div className="mb-3">
                                <AvField
                                    name="zip_code"
                                    label="Pin Code"
                                    placeholder="Enter Only number"
                                    type="number"
                                    value={destination.zip_code}
                                    errorMessage="Enter Only Number"
                                    validate={{
                                    required: { value: true },
                                    
                                    maxLength: {
                                        value: 6,
                                        errorMessage: "Numbers must be less than 7 digit"},
                                    minLength: {
                                        value: 6,
                                        errorMessage: "Numbers must be Grater than 5 digit"}   
                                    }}
                                />
                                </div>
                            </Col>
                            <Col md="6">
                                <div className="mb-3">
                                <Label className="form-label " htmlFor="coordinates">Coordinates</Label>
                                <AvField
                                    name="coordinates"
                                    placeholder="Coordinates"
                                    type="text"
                                    value={destination.coordinates}
                                    className="form-control"
                                    id="coordinates"
                                    validate={{
                                      required: { value: true },
                                    }}
                                    
                                />
                                </div>
                            </Col> 
                            </Row>
                            {this.state.is_place?
                                <Row>
                                    <Col md="6">
                                        <div className="mb-3">
                                            <Label className="form-label">Parent Destination</Label>
                                            <Select 
                                            onInputChange={this.onInputChange}
                                            value={selectedDestination}
                                            onChange={this.handleselectedNearestDestination}
                                            options={DestinationGroup}
                                            classNamePrefix="select2-selection"
                                            />

                                        </div>
                                    </Col>
                                    <Col md="6">
                                        <div className="mb-3">
                                            <Label className="form-label" htmlFor="destination_distance">Distance From Destination (km)</Label>
                                            <AvField
                                            name="destination_distance"
                                            placeholder="Distance From Destination"
                                            type="text"
                                            value = {destination.destination_distance}
                                            validate={{ required: { value: true } }}
                                            className="form-control"
                                            id="destination_distance" 
                                            />
                                        </div>
                                    </Col> 
                                </Row>  
                        :""}
                            <Row>
                            <div className="mb-3">
                                <Label className="form-label " htmlFor="price">Description</Label>
                                <Input
                                    type="textarea"
                                    id="textarea"
                                    rows="3"
                                    defaultValue={destination.description}
                                    placeholder="About Destination"
                                />
                            </div>
                            </Row>                                            
                        </CardBody>
                    </Card>
                    </Col>
                    <Col xl="6">
                    <Card>
                        <CardBody> 
                        <h4 className="card-title">Additional Detail</h4>
                          <Row>
                            <Col md="6">
                                <div className="mb-3">
                                <Label className="form-label " htmlFor="elevation">Elevation (m)</Label>
                                <AvField
                                    name="elevation"
                                    placeholder="Elevation"
                                    type="text"
                                    value={this.state.elevation}
                                    className="form-control"
                                    id="elevation"
                                    
                                />
                                </div>
                            </Col> 
                            <Col md="6">
                                <div className="mb-3">
                                <Label className="form-label " htmlFor="area">Area (km²)</Label>
                                <AvField
                                    name="area"
                                    placeholder="Area"
                                    type="text"
                                    
                                    value= {this.state.area}
                                    className="form-control"
                                    id="area"
                                    
                                />
                                </div>
                            </Col> 
                            </Row> 
                            <Row>
                            <Col md="6">
                                <div className="mb-3">
                                    <Label className="form-label " htmlFor="weather">Weather</Label>
                                    <AvField
                                    name="weather"
                                    placeholder="Weather"
                                    type="text"
                                    value={this.state.weather}
                                    className="form-control"
                                    id="weather"
                                    
                                    />
                                </div>
                            </Col> 
                            <Col md="6">
                                <div className="mb-3">
                                    <Label className="form-label " htmlFor="climate">Climate</Label>
                                    <AvField
                                    name="climate"
                                    placeholder="Climate"
                                    type="text"
                                    value={this.state.climate}
                                    className="form-control"
                                    id="climate"
                                    
                                    />
                                </div>
                            </Col> 
                            </Row>
                            <Row>
                            <Col md="6">
                                <div className="mb-3">
                                    <Label className="form-label">Nearest Bus Station</Label>
                                    <Select 
                                    value={selectedBusStation}
                                    onChange={this.handleSelectedBusStation}
                                    options={PlacesGroup}
                                    components={{ Menu: AddPlaces }}
                                    onInputChange={(e) => this.handleLoadNearestPlaces(`state__id=${selectedState.value}&search=${e}`)}
                                    classNamePrefix="select2-selection"
                                    />
                                </div>
                            </Col> 
                            <Col md="6">
                                <div className="mb-3">
                                    <Label className="form-label " htmlFor="bus_station_distance">Distance to the Bus Station (km)</Label>
                                    <AvField
                                    name="bus_station_distance"
                                    placeholder="Distance to the Railway Station"
                                    type="text"
                                    value={this.state.bus_station_distance}
                                    className="form-control"
                                    id="bus_station_distance"
                                    
                                    />
                                </div>
                            </Col> 
                            </Row>
                            <Row>
                            <Col md="6">
                                <div className="mb-3">
                                    <Label className="form-label">Nearest Railway Station</Label>
                                    <Select 
                                    value={selectedRailway}
                                    onChange={this.handleSelectedRailway}
                                    options={PlacesGroup}
                                    onFocus={() => this.handleLoadNearestPlaces(`state__id=${selectedState.value}&search=rail`)}
                                    components={{ Menu: AddPlaces }}
                                    classNamePrefix="select2-selection"
                                    />
                                </div>
                            </Col> 
                            <Col md="6">
                                <div className="mb-3">
                                    <Label className="form-label " htmlFor="railway_distance">Distance to the Railway Station (km)</Label>
                                    <AvField
                                    name="railway_distance"
                                    placeholder="Distance to the Railway Station"
                                    type="text"
                                    value={this.state.railway_distance}
                                    className="form-control"
                                    id="railway_distance"
                                    
                                    />
                                </div>
                            </Col> 
                            </Row>
                            <Row>
                            <Col md="6">
                                <div className="mb-3">
                                        <Label className="form-label">Nearest Airport</Label>
                                        <Select 
                                        value={selectedAirport}
                                        onChange={this.handleSelectedAirport}
                                        options={PlacesGroup}
                                        onFocus={() => this.handleLoadNearestPlaces(`state__id=${selectedState.value}&search=airport`)}
                                        components={{ Menu: AddPlaces }}
                                        classNamePrefix="select2-selection"
                                        />
                                    </div>
                                    
                                </Col> 
                                <Col md="6">
                                <div className="mb-3">
                                    <Label className="form-label " htmlFor="airport_distance">Distance to the Airport (km)</Label>
                                    <AvField
                                    name="airport_distance"
                                    placeholder="Distance to the Airport"
                                    type="text"
                                    value={this.state.airport_distance}
                                    className="form-control"
                                    id="airport_distance"
                                    
                                    />
                                </div>
                            </Col> 

                            </Row>
                                                                        
                            <FormGroup className="mb-1 mt-3">
                            {this.state.loading?(
                                <Spinner className="me-2 mt-2" color="primary" />
                            ):(
                                <div>
                            
                            <Button type="submit" color="primary" className="me-1">
                                Submit
                            </Button>{" "}
                            <Button type="button" onClick={() => this.props.history.goBack()} color="secondary">
                                Cancel
                            </Button>
                            </div>
                            )}
                        </FormGroup>      

                        </CardBody>
                    </Card>
                    </Col>
                </Row>
                </AvForm>
                <Row>
                    <Col xl="6">                        
                            <Card>
                                <CardBody> 
                                <h4 className="card-title">Gallery</h4>
                                {this.state.gallery_loading?
                                <div className="d-flex align-items-center justify-content-center m-5">
                                <Spinner className="me-2 mt-2" color="primary" />
                                </div>
                                :
                                <>
                                    <div className="table-responsive">
                                            <Table className="table-nowrap mb-0">
                                                <tbody>
                                                <tr key={'GalleryHeading'}>
                                                <th
                                                scope="row"
                                                >
                                                {"Image"}
                                                </th>
                                                <th
                                                scope="row"
                                                >
                                                {"Name"}
                                                </th>
                                                <th
                                                scope="row"
                                                >
                                                {"Default"}
                                                </th>
                                                <th
                                                scope="row"
                                                >
                                                {"Action"}
                                                </th>
                                            </tr> 
                                            {destination.image.map((item, i) => (
                                                <tr key={i+"image"}>
                                                <th
                                                scope="row"
                                                >
                                                <img className="rounded avatar-md" alt={item.name} src={BaseUrl+item.image} />
                                                </th>
                                                <th
                                                scope="row"
                                                >
                                               <p>{item.name}</p>
                                                </th>
                                                <th
                                                scope="row"
                                                >
                                                {item.is_default?
                                                    <>
                                                    <Input className="form-check-input m-2" type="radio" onChange={() =>this.handleDefaultImage(item)} name="exampleRadios" id={item.id} value={item.id} defaultChecked />
                                                    <Label className="form-check-label m-2" htmlFor={item.id}></Label>
                                                    </>
                                                    :
                                                    <>
                                                    <Input className="form-check-input m-2" type="radio" onChange={() =>this.handleDefaultImage(item)} name="exampleRadios" id={item.id} value={item.id} />
                                                    <Label className="form-check-label m-2" htmlFor={item.id}></Label>
                                                    </>                                           
                                                }
                                                </th>
                                                <th
                                                scope="row"
                                                >
                                                <Link to="#" onClick={() => this.setState({ selected_img: item, model_img_name:true })}  className="text-danger me-3"><i className="mdi mdi-pencil font-size-18"></i></Link>
                                                <Link to="#" onClick={() => this.setState({ image_alert_confirm: true, selectedId:item.id })}  className="text-danger"><i className="mdi mdi-trash-can font-size-18"></i></Link>
                                                
                                                </th>
                                            </tr> 
                                            ))}
                                            


                                                </tbody>
                                            </Table>
                                    </div>
                                    <Button type="button" className="btn-sm mt-4" onClick={this.tog_images} color="info"><i className=" fas fa-plus"></i></Button>
                                </>}
                                </CardBody>
                            </Card>

                    </Col>
                    {this.state.is_destination && !destination.state_location=== false?
                    <Col xl="6">                        
                            <Card>
                                <CardBody> 
                                <h4 className="card-title">Distance From Destinations</h4>
                                
                                  <div className="table-responsive">
                                          <Table className="table-nowrap mb-0">
                                              <tbody>
                                              <tr key={'Distances'}>
                                              <th
                                              scope="row"
                                              >
                                              {"Destination"}
                                              </th>
                                              <th
                                              scope="row"
                                              >
                                              {"Distance"}
                                              </th>
                                              <th
                                              scope="row"
                                              >
                                              {"Action"}
                                              </th>
                                          </tr> 
                                          {distances.map((item, i) => (
                                              <tr key={i+"image"}>
                                              <th
                                              scope="row"
                                              >
                                              {item.destination.name}
                                              </th>
                                              <th
                                              scope="row"
                                              >
                                              {item.distance} km
                                              </th>
                                              <th
                                              scope="row"
                                              >
                                                <Link to="#" onClick={() => this.handleEditDestination(item)}  className="text-primary me-3"><i className="mdi mdi-pencil font-size-18"></i></Link>
                                              <Link to="#" onClick={() => this.setState({ alert_confirm: true, selectedId:item.id })}  className="text-danger"><i className="mdi mdi-trash-can font-size-18"></i></Link>
                                              </th>
                                          </tr> 
                                          ))}
                                              </tbody>
                                          </Table>
                                  </div>
                                  <Button type="button" className="btn-sm mt-4" onClick={this.tog_destination} color="info"><i className=" fas fa-plus"></i></Button>
                                  
                                </CardBody>
                            </Card>

                    </Col>
                    :""}
                    
                    <Col xl="6">                        
                    <Card>
                        <CardBody> 
                        <h4 className="card-title">State Locations</h4>
                        {destination?.state_location && destination?.state_location !== false?
                          <div className="table-responsive">
                                  <Table className="table-nowrap mb-0">
                                      <tbody>
                                      <tr key={'state_location'}>
                                      <th
                                      scope="row"
                                      >
                                      {"Location"}
                                      </th>
                                      <th
                                      scope="row"
                                      >
                                      {"Action"}
                                      </th>
                                  </tr> 
                                  {state_level_location.sub_locations.map((item, i) => (
                                      <tr key={i+"image"}>
                                      <th
                                      scope="row"
                                      >
                                      {item.name}
                                      </th>
                                      <th
                                      scope="row"
                                      >
                                        
                                      <Link to="#" onClick={() => this.setState({ alert_sub_location_confirm: true, selectedId:item.id })}  className="text-danger"><i className="mdi mdi-trash-can font-size-18"></i></Link>
                                      </th>
                                  </tr> 
                                  ))}
                                      </tbody>
                                  </Table>
                          </div>:null}
                          <Button type="button" className="btn-sm mt-4" onClick={this.tog_state_destination} color="info"><i className=" fas fa-plus"></i></Button>
                          
                        </CardBody>
                    </Card>

            </Col>
                    
                </Row>
                <ActivityLog
                      location ={this.state.destination}
                      user = {this.obj.user}
                      access = {this.obj.access}
                      history = {this.props.history}
                     /> 
              </>
              :
                <div className="d-flex align-items-center justify-content-center min-vh-100">
            
                    <Spinner type="grow" className="me-2" color="secondary" />
                    <Spinner type="grow" className="me-2" color="secondary" />
                    <Spinner type="grow" className="me-2" color="secondary" />
                    <Spinner type="grow" className="me-2" color="secondary" />
            
                </div>
            }
            {/* Model Change Image Name  */}
            <Col sm={6} md={4} xl={3} className="mt-4">
               
               <Modal
                 isOpen={this.state.model_img_name}
                 toggle={this.tog_img_name}
                 centered={true}
               >
                 <ModalHeader toggle={this.tog_img_name}>
                 Change Image Name
                 </ModalHeader>
                 <ModalBody>
                   <AvForm className="needs-validation" onValidSubmit={this.handleAddImageNameSubmit} >
                     <Row>
                       <Col md="6">
                         <div className="mb-3">
                           <Label className="form-label " htmlFor="img_name">Name</Label>
                           <AvField
                             name="name"
                             placeholder="Name"
                             type="text"
                             value={this.state.selected_img?.name}
                             errorMessage="Enter Name"
                             className="form-control"
                             validate={{ required: { value: true } }}
                             id="img_name"
                           />
                         </div>
                       </Col> 
                     </Row>
                                       
                     <FormGroup className="mb-0">
                       {this.state.imagenameloading?(
                         <Spinner className="me-2 mt-2" color="primary" />
                       ):(
                         <div>
                     
                       <Button type="submit" color="primary" className="me-1">
                         Save
                       </Button>
                       </div>
                         )}
                     </FormGroup>     
                   </AvForm>

                 </ModalBody>
               </Modal>
             </Col>
            {/* Model Add City */}
            <Col sm={6} md={4} xl={3} className="mt-4">
               
               <Modal
                 isOpen={this.state.model_city}
                 toggle={this.tog_city}
                 centered={true}
               >
                 <ModalHeader toggle={this.tog_city}>
                 Add City
                 </ModalHeader>
                 <ModalBody>
                   <AvForm className="needs-validation" onValidSubmit={this.handleAddCitySubmit} >
           
                     <Row>
                       <Col md="6">
                         <div className="mb-3">
                           <Label className="form-label " htmlFor="city">City Name</Label>
                           <AvField
                             name="name"
                             placeholder="City Name "
                             type="text"
                             errorMessage="Enter City Name"
                             className="form-control"
                             validate={{ required: { value: true } }}
                             id="city"
                             
                           />
                         </div>
                       </Col> 
                     </Row>
                                       
                     <FormGroup className="mb-0">
                       {this.state.cityloading?(
                         <Spinner className="me-2 mt-2" color="primary" />
                       ):(
                         <div>
                     
                       <Button type="submit" color="primary" className="me-1">
                         Submit
                       </Button>
                       </div>
                         )}
                     </FormGroup>     
                   </AvForm>

                 </ModalBody>
               </Modal>
             </Col>
            {/* Model Add State */}
            <Col sm={6} md={4} xl={3} className="mt-4">
               
               <Modal
                 isOpen={this.state.model_state}
                 toggle={this.tog_state}
                 centered={true}
               >
                 <ModalHeader toggle={() => this.setState({ model_state: false })}>
                 Add State
                 </ModalHeader>
                 <ModalBody>
                   <AvForm className="needs-validation" onValidSubmit={this.handleAddStateSubmit} >
           
                     <Row>
                       <Col md="6">
                         <div className="mb-3">
                           <Label className="form-label " htmlFor="name">State Name</Label>
                           <AvField
                             name="name"
                             placeholder="State Name "
                             type="text"
                             errorMessage="Enter State Name"
                             className="form-control"
                             validate={{ required: { value: true } }}
                             id="name"
                             
                           />
                         </div>
                       </Col> 
                     </Row>
                                       
                     <FormGroup className="mb-0">
                       {this.state.stateloading?(
                         <Spinner className="me-2 mt-2" color="primary" />
                       ):(
                         <div>
                     
                       <Button type="submit" color="primary" className="me-1">
                         Submit
                       </Button>
                       </div>
                         )}
                     </FormGroup>     
                   </AvForm>

                 </ModalBody>
               </Modal>
             </Col>
             {/* Add destination Distance */}
             <Col sm={6} md={4} xl={3} className="mt-4">
               
              <Modal
                 isOpen={this.state.model_destination}
                 toggle={this.tog_destination}
                 centered={true}
               >
                 <ModalHeader toggle={() => this.setState({ model_destination: false })}>
                 Add Distance From Destinations
                 </ModalHeader>
                 <ModalBody>
                   <AvForm className="needs-validation" onValidSubmit={this.handleDestinactionDistanceSubmit} >
           
                   {Array.from(Array(this.state.count)).map((c,  index)=> {
                          return (
                              <Row>
                                <Col md="6">
                                  <div className="mb-3">
                                      <Label className="form-label">Destination</Label>
                                      <Select 
                                      onInputChange={this.onInputChange}
                                      onChange={(e) => this.handleSelectedDestinations(e, index)}
                                      options={All_DestinationGroup}
                                      classNamePrefix="select2-selection"
                                      />

                                  </div>
                                </Col>
                                <Col md="6">
                                    <div className="mb-3">
                                      <Label className="form-label" htmlFor={index}>Distance From Destination (km)</Label>
                                      <AvField
                                        name="destination_distance"
                                        placeholder="Distance From Destination"
                                        type="text"
                                        className="form-control"
                                        id={index} 
                                      />
                                    </div>
                                  </Col> 
                              </Row>
                            )
                          })}
                    
                       
                        <Button type="button" className="btn-sm" onClick={this.addInput} color="info"><i className=" fas fa-plus"></i></Button>
                        {" "}
                        {this.state.count >1 ? <Button className="btn-sm" type="button" onClick={this.removeInput} color="danger"><i className=" fas fa-minus"></i></Button>
                        :""}
                                       
                     <FormGroup className="mb-0 mt-2">
                       {this.state.destinationloading?(
                         <Spinner className="me-2 mt-2" color="primary" />
                       ):(
                      <div>
                     
                       <Button type="submit" color="primary" className="me-1">
                         Submit
                       </Button>
                       </div>
                         )}
                     </FormGroup>     
                   </AvForm>

                 </ModalBody>
               </Modal>
             </Col>
             {/* Model Edit Destination */}
             <Col sm={6} md={4} xl={3} className="mt-4">
               
               <Modal
                  isOpen={this.state.model_editDestination}
                  toggle={this.tog_editDestination}
                  centered={true}
                >
                  <ModalHeader toggle={() => this.setState({ model_editDestination: false })}>
                  Edit Distance From {this.state.selectedEditDestination.label}
                  </ModalHeader>
                  <ModalBody>
                    <AvForm className="needs-validation" onValidSubmit={this.handleEditDestinationSubmit} >
                               <Row>
                                 <Col md="12">
                                   <div className="mb-3">
                                       <Label className="form-label">Destination</Label>
                                        <Select 
                                          onInputChange={this.onInputChange}
                                          value={this.state.selectedEditDestination}
                                          onChange={this.handleselectedEditDestination}
                                          options={All_DestinationGroup}
                                          classNamePrefix="select2-selection"
                                       />
 
                                   </div>
                                 </Col>
                                </Row>
                                <Row>
                                 <Col md="12">
                                     <div className="mb-3">
                                       <Label className="form-label" htmlFor={"destination_distance"}>Distance From Destination (km)</Label>
                                       <AvField
                                         name="destinationDistance"
                                         placeholder="Distance From Destination"
                                         type="text"
                                         value={this.state.selectedEditDistance}
                                         className="form-control"
                                         id={"destination_distance"} 
                                       />
                                     </div>
                                   </Col> 
                               </Row>                                        
                      <FormGroup className="mb-0 mt-2">
                        {this.state.editDestinationloading?(
                          <Spinner className="me-2 mt-2" color="primary" />
                        ):(
                       <div>
                      
                        <Button type="submit" color="primary" className="me-1">
                          Submit
                        </Button>
                        </div>
                          )}
                      </FormGroup>     
                    </AvForm>
 
                  </ModalBody>
                </Modal>
              </Col>
              {/* Model Add Images */}
              <Col sm={6} md={4} xl={3} className="mt-4">
    
                <Modal
                  isOpen={this.state.model_images}
                  toggle={this.tog_images}
                  centered={true}
                >
                  <ModalHeader toggle={() => this.setState({ model_images: false, selectedFiles: [] })}>
                  Add Images
                  </ModalHeader>
                  <ModalBody>
                    <AvForm className="needs-validation" onValidSubmit={this.handleImageSubmit} >
                      <Row>
                        <Col md="12">
                            <div className="mb-3">
                            <Label className="form-label " htmlFor="image_name">Name</Label>
                            <AvField
                                name="image_name"
                                placeholder="Name"
                                type="text"
                                errorMessage="Enter Name"
                                className="form-control"
                                validate={{ required: { value: true } }}
                                id="image_name" 
                            />
                            </div>
                        </Col> 
                      </Row>
                      <Row>
                          <Col md="12">
                            <Dropzone
                              accept='.jpeg,.jpg,.JPG,.JPEG,.PNG,.png'
                              maxSize={1000000}
                              onDrop = {(acceptedFiles, fileRejections) => {
                                this.handleRejectedFiles(fileRejections)
                                this.handleAcceptedFiles(acceptedFiles)
                                }}
                            >
                              {({ getRootProps, getInputProps }) => (
                              <div className="dropzone">
                                <div
                                  className="dz-message needsclick"
                                  {...getRootProps()}
                                  >
                                  <input {...getInputProps()} />
                                  <div className="mb-3">
                                      <i className="display-4 text-muted ri-upload-cloud-2-line"></i>
                                  </div>
                                  <h6>Drop only .jpeg/.png Images here or click to upload.</h6>
                                  <h6>Images size is less than 1 MB.</h6>
                                </div>
                              </div>
                              )}
                            </Dropzone>
                            <div
                                className="dropzone-previews mt-3"
                                id="file-previews"
                            >
                                {this.state.selectedFiles.map((f, i) => {
                                return (
                                    <Card
                                    className="mt-1 mb-0 shadow-none border dz-processing dz-image-preview dz-success dz-complete"
                                    key={i + "-file"}
                                    >
                                    <div className="p-2">
                                        <Row className="align-items-center">
                                        <Col className="col-auto">
                                            <img
                                            data-dz-thumbnail=""
                                            height="80"
                                            className="avatar-sm rounded bg-light"
                                            alt={f.name}
                                            src={f.preview}
                                            />
                                        </Col>
                                        <Col>
                                            <Link
                                            to="#"
                                            className="text-muted fw-bold"
                                            >
                                            {f.name}
                                            </Link>
                                            <p className="mb-0">
                                            <strong>{f.formattedSize}</strong>
                                            </p>
                                        </Col>
                                        </Row>
                                    </div>
                                    </Card>
                                );
                                })}
                              {this.state.rejectedFiles.length > 0?
                                <>
                                  <hr></hr>
                                  <p style={{ color: "red", padding: 5, margin: 0, fontSize: 14 }}>
                                    {"Rejected Files: File size is grater than 1 MB or Invalid File Format"}
                                  </p>
                                </>
                              :""}
                              {this.state.rejectedFiles.map((f, i) => {
                              return (
                                  <Card
                                  className="mt-1 mb-0 shadow-none border dz-processing dz-image-preview dz-success dz-complete"
                                  key={i + "-rejected_file"}
                                  >
                                  <div className="p-2">
                                      <Row className="align-items-center">
                                      <Col className="col-auto">
                                          <img
                                          data-dz-thumbnail=""
                                          height="80"
                                          className="avatar-sm rounded bg-light"
                                          alt={f.name}
                                          src={f.preview}
                                          />
                                      </Col>
                                      <Col>
                                          <Link
                                          to="#"
                                          className="text-muted fw-bold"
                                          >
                                          {f.name}
                                          </Link>
                                          <p className="mb-0">
                                          <strong>{f.formattedSize}</strong>
                                          </p>
                                      </Col>
                                      </Row>
                                  </div>
                                  </Card>
                                );
                              })}
                            </div>
                          </Col>
                        </Row> 

                      
                                        
                      <FormGroup className="mb-0">
                        {this.state.imagesloading?(
                          <Spinner className="me-2 mt-2" color="primary" />
                        ):(
                          <div>
                      
                        <Button type="submit" color="primary" className="me-1">
                          Submit
                        </Button>
                        </div>
                          )}
                      </FormGroup>     
                    </AvForm>

                  </ModalBody>
                </Modal>
               </Col>
                {/* Model Add Place */}
               <Col sm={6} md={4} xl={3} className="mt-4">
               
               <Modal
                 isOpen={this.state.model_place}
                 toggle={this.tog_place}
                 centered={true}
               >
                 <ModalHeader toggle={this.tog_place}>
                 Add Place
                 </ModalHeader>
                 <ModalBody>
                   <AvForm className="needs-validation" onValidSubmit={this.handleAddSubPlacesSubmit} >
           
                     <Row>
                       <Col md="6">
                         <div className="mb-3">
                           <Label className="form-label " htmlFor="place_name">Place Name</Label>
                           <AvField
                             name="place_name"
                             placeholder="Place Name"
                             type="text"
                             errorMessage="Enter City Name"
                             className="form-control"
                             validate={{ required: { value: true } }}
                             id="place_name"
                             
                           />
                         </div>
                       </Col> 
                     </Row>
                     <Row>
                          <Col md="12">
                            <Dropzone
                              accept='.jpeg,.jpg,.JPG,.JPEG,.PNG,.png'
                              maxSize={1000000}
                              onDrop = {(acceptedFiles, fileRejections) => {
                                this.handleRejectedFiles(fileRejections)
                                this.handleAcceptedFiles(acceptedFiles)
                                }}
                            >
                              {({ getRootProps, getInputProps }) => (
                              <div className="dropzone">
                                <div
                                  className="dz-message needsclick"
                                  {...getRootProps()}
                                  >
                                  <input {...getInputProps()} />
                                  <div className="mb-3">
                                      <i className="display-4 text-muted ri-upload-cloud-2-line"></i>
                                  </div>
                                  <h4>Drop only .jpeg/.png Images here or click to upload.</h4>
                                  <h4>Images size is less than 1 MB.</h4>
                                </div>
                              </div>
                              )}
                            </Dropzone>
                            <div
                                className="dropzone-previews mt-3"
                                id="file-previews"
                            >
                                {this.state.selectedFiles.map((f, i) => {
                                return (
                                    <Card
                                    className="mt-1 mb-0 shadow-none border dz-processing dz-image-preview dz-success dz-complete"
                                    key={i + "-file"}
                                    >
                                    <div className="p-2">
                                        <Row className="align-items-center">
                                        <Col className="col-auto">
                                            <img
                                            data-dz-thumbnail=""
                                            height="80"
                                            className="avatar-sm rounded bg-light"
                                            alt={f.name}
                                            src={f.preview}
                                            />
                                        </Col>
                                        <Col>
                                            <Link
                                            to="#"
                                            className="text-muted fw-bold"
                                            >
                                            {f.name}
                                            </Link>
                                            <p className="mb-0">
                                            <strong>{f.formattedSize}</strong>
                                            </p>
                                        </Col>
                                        </Row>
                                    </div>
                                    </Card>
                                );
                                })}
                              {this.state.rejectedFiles.length > 0?
                                <>
                                  <hr></hr>
                                  <p style={{ color: "red", padding: 5, margin: 0, fontSize: 14 }}>
                                    {"Rejected Files: File size is grater than 1 MB or Invalid File Format"}
                                  </p>
                                </>
                              :""}
                              {this.state.rejectedFiles.map((f, i) => {
                              return (
                                  <Card
                                  className="mt-1 mb-0 shadow-none border dz-processing dz-image-preview dz-success dz-complete"
                                  key={i + "-rejected_file"}
                                  >
                                  <div className="p-2">
                                      <Row className="align-items-center">
                                      <Col className="col-auto">
                                          <img
                                          data-dz-thumbnail=""
                                          height="80"
                                          className="avatar-sm rounded bg-light"
                                          alt={f.name}
                                          src={f.preview}
                                          />
                                      </Col>
                                      <Col>
                                          <Link
                                          to="#"
                                          className="text-muted fw-bold"
                                          >
                                          {f.name}
                                          </Link>
                                          <p className="mb-0">
                                          <strong>{f.formattedSize}</strong>
                                          </p>
                                      </Col>
                                      </Row>
                                  </div>
                                  </Card>
                                );
                              })}
                            </div>
                          </Col>
                        </Row> 
                                       
                     <FormGroup className="mb-0">
                       {this.state.placeloading?(
                         <Spinner className="me-2 mt-2" color="primary" />
                       ):(
                         <div>
                     
                       <Button type="submit" color="primary" className="me-1">
                         Submit
                       </Button>
                       </div>
                         )}
                     </FormGroup>     
                   </AvForm>

                 </ModalBody>
               </Modal>
             </Col>
             {/* Mopdel for Change destination to Place  */}
             <Col sm={6} md={4} xl={3} className="mt-4">
               
               <Modal
                 isOpen={this.state.model_change_to_place}
                 toggle={this.tog_change_to_place}
                 centered={true}
               >
                 <ModalHeader toggle={() => this.setState({ model_change_to_place: false })}>
                 Select Parent Destination For {destination.name}
                 </ModalHeader>
                 <ModalBody>
                   <AvForm className="needs-validation" onValidSubmit={this.handleChangeToPlace} >
           
                     <Row>
                     <Col md="6">
                          <div className="mb-3">
                              <Label className="form-label">Parent Destination</Label>
                              <Select 
                              value={selectedDestination}
                              onChange={this.handleselectedParentDestination}
                              options={DestinationGroup}
                              classNamePrefix="select2-selection"
                              />

                          </div>
                      </Col>
                     </Row>
                                       
                     <FormGroup className="mb-0">
                         <div>
                       <Button type="submit" color="primary" className="me-1">
                         Submit
                       </Button>
                       </div>
                     </FormGroup>     
                   </AvForm>

                 </ModalBody>
               </Modal>
             </Col>
             {/* Add State Destination */}
             <Col sm={6} md={4} xl={3} className="mt-4">
               
              <Modal
                 isOpen={this.state.model_state_destination}
                 toggle={this.tog_state_destination}
                 centered={true}
               >
                 <ModalHeader toggle={() => this.setState({ model_state_destination: false })}>
                  Add Locations
                 </ModalHeader>
                 <ModalBody>
                   <AvForm className="needs-validation" onValidSubmit={this.addSubLocations} >
           
                 
                              <Row>
                                <Col md="12">
                                  <div className="mb-3">
                                      <Label className="form-label">Destination</Label>
                                      <Select 
                                        options={PlacesGroup}
                                        value= {this.state.selectedSubLocations}
                                        onChange={(e) => this.setState({selectedSubLocations:e})}
                                        onInputChange={(e) => this.handleLoadNearestPlaces(`state__id=${selectedState.value}&search=${e}`)}
                                        classNamePrefix="select2-selection"
                                        isMulti={true}
                                      />

                                  </div>
                                </Col>
                                 
                              </Row>
                     <FormGroup className="mb-0 mt-2">
                       {this.state.destinationloading?(
                         <Spinner className="me-2 mt-2" color="primary" />
                       ):(
                      <div>
                     
                       <Button type="submit" color="primary" className="me-1">
                         Submit
                       </Button>
                       </div>
                         )}
                     </FormGroup>     
                   </AvForm>

                 </ModalBody>
               </Modal>
             </Col>

              {this.state.alert_confirm ? (
                  <SweetAlert
                  title="Are you sure?"
                  warning
                  showCancel
                  confirmBtnBsStyle="success"
                  cancelBtnBsStyle="danger"
                  onConfirm={() => this.handleDistanceDelete(this.state.selectedId)}
                  onCancel={() =>
                      this.setState({
                          alert_confirm: false,
                          image_id:"",

                      })
                  }
                  >
                  You won't be able to revert this!
                  </SweetAlert>
                ) : null}

              {this.state.success_confirm ? (
                  <SweetAlert
                  success
                  title={this.state.dynamic_title}
                  confirmBtnBsStyle="success"
                  cancelBtnBsStyle="danger"
                  onConfirm={() => this.setState({ success_confirm: false, alert_confirm : false })}
                  >
                      {this.state.dynamic_description}
                  </SweetAlert>
                )
                : null}
              {/* Alert for Image delete */}
              {this.state.image_alert_confirm ? (
                  <SweetAlert
                  title="Are you sure?"
                  warning
                  showCancel
                  confirmBtnBsStyle="success"
                  cancelBtnBsStyle="danger"
                  onConfirm={() => this.handleImageDelete(this.state.selectedId)}
                  onCancel={() =>
                      this.setState({
                          image_alert_confirm: false,
                          selectedId:"",

                      })
                  }
                  >
                  You won't be able to revert this!
                  </SweetAlert>
                ) : null}

              {this.state.image_success_confirm ? (
                  <SweetAlert
                  success
                  title={this.state.dynamic_title}
                  confirmBtnBsStyle="success"
                  cancelBtnBsStyle="danger"
                  onConfirm={() => this.setState({ image_success_confirm: false, image_alert_confirm : false })}
                  >
                      {this.state.dynamic_description}
                  </SweetAlert>
                )
                : null}
                {/* Convert Place to Destination */}
                {this.state.destination_alert_confirm ? (
                  <SweetAlert
                  title="Are you sure?"
                  warning
                  showCancel
                  confirmBtnBsStyle="success"
                  cancelBtnBsStyle="danger"
                  onConfirm={this.handleChangeToDestination}
                  onCancel={() =>
                      this.setState({
                          destination_alert_confirm: false,
                      })
                  }
                  >
                  You Really want to Convert {destination.name} as a Destination . 
                  </SweetAlert>
                ) : null}

              {this.state.destination_success_confirm ? (
                  <SweetAlert
                  success
                  title={this.state.dynamic_title}
                  confirmBtnBsStyle="success"
                  cancelBtnBsStyle="danger"
                  onConfirm={() => this.setState({ destination_success_confirm: false, destination_alert_confirm : false })}
                  >
                      {this.state.dynamic_description}
                  </SweetAlert>
                )
                : null}
                {/* delete state Locations  */}
                
              {this.state.alert_sub_location_confirm ? (
                  <SweetAlert
                  title="Are you sure?"
                  warning
                  showCancel
                  confirmBtnBsStyle="success"
                  cancelBtnBsStyle="danger"
                  onConfirm={() => this.deleteSubLocation(this.state.selectedId)}
                  onCancel={() =>
                      this.setState({
                        alert_sub_location_confirm: false,
                        selectedId:"",

                      })
                  }
                  >
                  You won't be able to revert this!
                  </SweetAlert>
                ) : null}

              {this.state.sub_location_success_confirm ? (
                  <SweetAlert
                  success
                  title={this.state.dynamic_title}
                  confirmBtnBsStyle="success"
                  cancelBtnBsStyle="danger"
                  onConfirm={() => this.setState({ alert_sub_location_confirm: false, sub_location_success_confirm : false })}
                  >
                      {this.state.dynamic_description}
                  </SweetAlert>
                )
                : null}


          </Container>
        </div>
      }
      </React.Fragment>
    );
  }
}

export default EditLocation;
